var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.162 0H2.838A2.847 2.847 0 0 0 0 2.838v8.61a2.848 2.848 0 0 0 2.838 2.84h.02v2.863l4.765-2.862h9.54A2.847 2.847 0 0 0 20 11.45V2.838A2.847 2.847 0 0 0 17.162 0zM4.286 8.574a1.431 1.431 0 0 1-1.429-1.428c0-.787.642-1.429 1.429-1.429s1.428.642 1.428 1.429c0 .79-.639 1.428-1.428 1.428zm5.714 0a1.431 1.431 0 0 1-1.429-1.428c0-.787.642-1.429 1.429-1.429s1.429.642 1.429 1.429A1.43 1.43 0 0 1 10 8.574zm5.717 0a1.431 1.431 0 0 1-1.428-1.428c0-.787.641-1.429 1.428-1.429a1.428 1.428 0 1 1 0 2.857z",
    fillRule: "nonzero"
  })));
};
export default SvgMessage;